"use client"

import Image from "next/image"

export default function CourseFeatures() {
  const features = [
    {
      icon: "/course/enterprise-ready-icon.webp",
      title: "Enterprise-Ready Design Principles",
      description: "",
    },
    {
      icon: "/course/python-notebook-icon.webp",
      title: "Python Notebook for Execution",
      description: "",
    },
    {
      icon: "/course/enterprise-agentic-architecture-icon.webp",
      title: "Enterprise Agentic Architectures",
      description: "",
    },
    {
      icon: "/course/guest-lecture.webp",
      title: "Guest Lectures from Industry Practitioners",
      description: "",
    },
  ]

  return (
    <section className="relative py-16 sm:py-20 lg:py-24 overflow-hidden bg-slate-950">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(0,158,61,0.08),transparent_60%)]"></div>

      <div className="relative z-10">
        <div className="text-center mb-4 sm:mb-6">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-montserrat font-bold mb-3" style={{ color: "#FFFFFF" }}>
            Why Take This Course?
          </h2>
          <p
            className="text-lg sm:text-xl max-w-4xl mx-auto leading-relaxed font-vietnam mb-3"
            style={{ color: "#FFFFFF", opacity: 0.8 }}
          >
            Building AI agents is more than calling an LLM. Modern enterprise systems demand agentic mindset and best
            frameworks for orchestration of multiple agents.
          </p>
          <p className="text-lg font-vietnam font-semibold" style={{ color: "#009E3D" }}>
            In this course you will get:
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative border-2 border-green-500/60 rounded-xl py-8 px-5 hover:border-green-500/80 transition-all duration-300 text-center bg-slate-900/40 flex flex-col justify-center items-center overflow-hidden"
              style={{
                boxShadow: "0 0 20px rgba(34, 197, 94, 0.2)",
              }}
            >
              {/* Subtle green gradient from top-left to bottom-right, visible only in bottom right */}
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-green-500/10 pointer-events-none"></div>

              <div className="mb-6 relative z-10">
                <Image
                  src={feature.icon || "/placeholder.svg"}
                  alt={feature.title}
                  width={40}
                  height={40}
                  className="object-contain w-10 h-10 brightness-0 invert mx-auto"
                />
              </div>
              <h3 className="text-lg font-vietnam font-medium text-white leading-tight relative z-10">
                {feature.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
